module.exports = function(Swiper) {

    if ( document.querySelector('.jobs') ) {
        fSwiper()
    }

    function fSwiper() {
        let swiper = new Swiper('.jobs .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
            breakpoints: {
                576: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                }
            }
        });
        if ( window.innerWidth < 960 ) {
            swiper = new Swiper('.jobs .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    }
                }
            });
        } else {
            // const swiper = new Swiper('.jobs .swiper-container', {});
            swiper.destroy()
        }
    }

};